module.exports = __webpack_public_path__ + "static/IMG_0068.d8998664.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/examples/IMG_0068.jpg
// module id = 574
// module chunks = 35783957827783